import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';
import { activityData } from '../mock/mock';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="rounded-lg border border-white/10 bg-black/85 px-3 py-2 backdrop-blur">
      <p className="text-[10px] uppercase tracking-widest text-white/50 font-mono mb-1">Run {label}</p>
      {payload.map((p) => (
        <p key={p.name} className="text-xs font-mono" style={{ color: p.color }}>
          {p.name === 'pages' ? 'Pages crawlées' : 'Produits extraits'}: {p.value}
        </p>
      ))}
    </div>
  );
};

const ActivityChart = () => {
  return (
    <section className="rounded-2xl border border-white/5 bg-gradient-to-b from-white/[0.02] to-transparent p-6">
      <p className="text-[10px] uppercase tracking-[0.25em] text-white/40 font-mono mb-6">Activité · Pages et produits par run</p>
      <div className="h-[320px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={activityData} margin={{ top: 10, right: 20, left: 0, bottom: 10 }}>
            <defs>
              <filter id="glow">
                <feGaussianBlur stdDeviation="2" result="coloredBlur" />
                <feMerge>
                  <feMergeNode in="coloredBlur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            <CartesianGrid stroke="rgba(255,255,255,0.05)" strokeDasharray="3 6" vertical={false} />
            <XAxis dataKey="run" stroke="rgba(255,255,255,0.4)" tick={{ fontSize: 11, fontFamily: 'monospace' }} tickLine={false} axisLine={{ stroke: 'rgba(255,255,255,0.1)' }} />
            <YAxis hide />
            <Tooltip content={<CustomTooltip />} cursor={{ stroke: 'rgba(34,211,238,0.2)' }} />
            <Legend
              iconType="line"
              wrapperStyle={{ fontSize: 11, fontFamily: 'monospace', paddingTop: 10 }}
              formatter={(v) => <span className="text-white/70">{v === 'pages' ? 'Pages crawlées' : 'Produits extraits'}</span>}
            />
            <Line
              type="monotone"
              dataKey="pages"
              stroke="#22d3ee"
              strokeWidth={2.5}
              dot={{ r: 4, fill: '#0a1220', stroke: '#22d3ee', strokeWidth: 2 }}
              activeDot={{ r: 6, fill: '#22d3ee', stroke: '#fff', strokeWidth: 2 }}
              filter="url(#glow)"
            />
            <Line
              type="monotone"
              dataKey="produits"
              stroke="#ec4899"
              strokeWidth={2.5}
              dot={{ r: 4, fill: '#0a1220', stroke: '#ec4899', strokeWidth: 2 }}
              activeDot={{ r: 6, fill: '#ec4899', stroke: '#fff', strokeWidth: 2 }}
              filter="url(#glow)"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
};

export default ActivityChart;
